import React from 'react'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'

export const TabContainer = styled(Flex)`
  margin-top: 10px;
  width: ${props => (props?.width ? props?.width : 'fit-content')};
  justify-content: center;
  align-items: center;

  border: ${props =>
    props?.customBorder
      ? 'none'
      : props?.activeStyle?.border
      ? props?.activeStyle?.border
      : '1px solid #e3deff'};

  border-radius: ${props =>
    props?.activeStyle?.borderRadius
      ? props?.activeStyle?.borderRadius
      : '10px'};
  cursor: ${props => (props?.disabled ? 'not-allowed' : 'pointer')};
  background: ${props =>
    props?.disabled ? COLORS.DISABLED_SECONDARY : 'white'};
  height: ${props =>
    props?.activeStyle?.height ? props?.activeStyle?.height : '38px'};
  margin-bottom: ${props =>
    props?.tabMarginBottom ? props?.tabMarginBottom : '10px'};
  border-bottom: 1px solid #e3deff;
`

export const TabChildItem = styled.div`
  font-weight: ${props =>
    props?.normalFontWeight ? props?.normalFontWeight : FONT.FW_600};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${props =>
    props.active
      ? props?.activeStyle?.color
        ? props?.activeStyle?.color
        : '#FBFAFF'
      : props?.normalTextColor
      ? props?.normalTextColor
      : '#3249D7'};
  background-color: ${props =>
    props.active
      ? props?.activeStyle?.background
        ? props?.activeStyle?.background
        : '#3249D7'
      : 'unset'};
  padding: 10px 20px;
  border-radius: ${props =>
    props?.activeStyle?.borderRadius
      ? props?.activeStyle?.borderRadius
      : '8px'};
  transition: 0.5s;
  pointer-events: ${props =>
    props?.disabled ? 'none' : props?.pointerEventsNone ? 'none' : 'auto'};
  opacity: ${props => (props?.disabled ? '0.5' : '1')};
  border: ${props =>
    props?.activeStyle?.border
      ? props?.activeStyle?.border
      : props.active
      ? '1px solid #e3deff'
      : 'none'};
  flex: ${props => (props?.equalSpace ? '1 1 0%' : 'unset')};
  text-align: ${props => (props?.alignText ? props?.alignText : 'left')};
  border-bottom: ${props =>
    props?.activeStyle?.borderBottom && props?.active
      ? props?.activeStyle?.borderBottom
      : 'unset'};
  height: ${props => props?.activeStyle?.height};
  border-left: ${props =>
    props?.showBorderBetween ? '1px solid  #e3deff' : 'unset'};
  border-right: ${props =>
    props?.showBorderBetween ? '1px solid  #e3deff' : 'unset'};
`
const ToggleThreeOptions = ({
  handleClick,
  disabled = false,
  tabs,
  current,
  equalSpace = false,
  width,
  alignText,
  activeStyle,
  normalTextColor,
  normalFontWeight,
  tabMarginBottom,
  pointerEventsNone,
  defaultColor,
}) => {
  return (
    <TabContainer
      disabled={disabled}
      border={tabs?.length <= 0}
      width={width}
      equalSpace={equalSpace}
      activeStyle={activeStyle}
      customBorder={tabs?.length <= 0}
      tabMarginBottom={tabMarginBottom}
    >
      {tabs.map((tab, index) => {
        return (
          <TabChildItem
            active={tab.value === current}
            onClick={() => handleClick(tab)}
            disabled={disabled}
            key={index + 'tabItem'}
            equalSpace={equalSpace}
            alignText={alignText}
            activeStyle={activeStyle}
            normalTextColor={normalTextColor}
            normalFontWeight={normalFontWeight}
            showBorderBetween={
              activeStyle?.showBorderBetween &&
              index === activeStyle?.showBorderBetween
            }
            pointerEventsNone={pointerEventsNone}
          >
            {tab.label}
          </TabChildItem>
        )
      })}
    </TabContainer>
  )
}

export default ToggleThreeOptions
